// src/lib/session.js
// Reads user profile from the single localStorage "user" key.
// Used by non-React code (helpers, loggers) that can't call useSessionUser().

export function readLegacyUser() {
    try {
        const u = JSON.parse(localStorage.getItem('user') || '{}');
        return {
            userId:   u.UserID ?? u.userId ?? '',
            username: u.FullName ?? u.UserName ?? u.LoginName ?? u.username ?? u.name ?? '',
            roleName: u.RoleName ?? u.roleName ?? '',
        };
    } catch {
        return { userId: '', username: '', roleName: '' };
    }
}

export function resolveSession(sessionUser) {
    // 1) SessionContext (source of truth)
    const s = {
        userId:   sessionUser?.userId   ?? '',
        username: sessionUser?.username ?? '',
        roleName: sessionUser?.roleName ?? '',
    };

    // 2) localStorage fallback (for non-React code paths)
    const l = readLegacyUser();

    // Priority: Session → LocalStorage
    const userId   = s.userId   || l.userId   || '';
    const username = s.username || l.username || '';
    const roleName = (s.roleName || l.roleName || '').toUpperCase();

    return { userId, username, roleName };
}
